import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as GlobalVariables from '../globals/globals';
import * as $ from 'jquery';

var COMP = environment.component.transparency;

@Component({
  selector: 'app-transparency-data',
  templateUrl: './transparency-data.component.html',
  styleUrls: ['./transparency-data.component.css']
})
export class TransparencyDataComponent implements OnInit, OnDestroy {
  lang = 1;
  testmode = (environment.testmode || localStorage.getItem('editmode')=='1');
  admin_url = environment.url_django;
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qcgroups : Array<QuestionCategoryGroup>=[];
  qctypes : Array<QuestionCategoryType>=[];
  qtypes : Array<any>=[];
  qctypes_new : Array<any>=[];
  qtypes_new : Array<any>=[];
  rows: Array<Object>=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService){}

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".integrity-click").addClass("header_active")
    
    this.lang = GlobalVariables.findTranslationOptionsIndex(window);

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$
    .subscribe(
       data => {

        var qtindex = 0;
        var qtindexobj = {};
        var qtindexrevarr = [];
        var qct = data['question_category_type'];
        this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});

        //create an array of question category types using order as array index
        for (var i=0; i < qct.length; i++){
          var span = qct[i].question_type.length;
          if(qct[i].average)
            span += 1;
          if(qct[i].positive_response_percent)
            span += 1;
          this.qctypes[qct[i].order-1] = {"name":qct[i].name,"span":span,"question_type":qct[i].question_type,
            "category_group":qct[i].category_group, "order":qct[i].order,
            "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
        }
        //slice the last element is for Pool
        this.qctypes.splice(-1,1);

        //create an array of question category type groups
        var qcgroup=this.qctypes[0].category_group;
        var groupspan=0;
        for (var i=0; i < this.qctypes.length; i++){
          if(this.qctypes[i].category_group == qcgroup){
            groupspan += this.qctypes[i].span;
          }
          else{
            this.qcgroups.push({"name":qcgroup,"span":groupspan});
            qcgroup = this.qctypes[i].category_group;
            groupspan = this.qctypes[i].span;
          }
        }
        this.qcgroups.push({"name":qcgroup,"span":groupspan});

        //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
        for (var i=0; i < this.qctypes.length; i++){

          var qctypeobj = this.qctypes[i];
          var qtarr :any = this.qctypes[i].question_type;

          //create an array of qtypes in one qctype
          var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
          for (var j=0; j < qtarr.length; j++)
            arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order,display_text:qtarr[j].display_text};

          //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
          //and reverse lookup columnorder => qtype
          for (var k=0; k < arr.length; k++){
            this.qtypes.push(arr[k]);
            qtindexobj[arr[k].id] = qtindex;
            qtindexrevarr[qtindex] = arr[k].name;
            qtindex++;
          }

          //move qtindex forward to add columns for avearage and response if needed
          if(qctypeobj.average){
            this.qtypes.push({id:0,"name":"Average",order:this.qtypes[this.qtypes.length-1].order, display_text: "Average"});
            qtindexrevarr[qtindex] = "Average";
            qtindex++;
          }
          if(qctypeobj.positive_response_percent){
            this.qtypes.push({id:0,"name":"+ve Response %",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of +ve Response for "+this.qctypes[i].category_group});
            qtindexrevarr[qtindex] = "Response";
            qtindex++;
          }

        }
        this.qtindexobj = qtindexobj;
        this.qtindexrevarr = qtindexrevarr;

        var ctar = data['category'];
        var rows = {};
        var row = {};
        function label_name(ct){
          return ct.name.replace("Target ","").replace("Indicator ","");
          }
        for (var c = 0; c < ctar.length; c++){
          var ct = ctar[c];
          row["catname"] = label_name(ct);
          var scl = ct.sub_category.length;
          row["rowspan"] = scl;
          var catrow1 = true;
          for (var sc = 0; sc < scl; sc++){
            var newrow = {catname:row["catname"], rowspan:row["rowspan"]};
            var sct = ct.sub_category[sc];
            newrow["subcatname"] = label_name(sct);
            newrow["catrow"] = catrow1;
            if(sct.order == 2)
              newrow["rowspan"] = 0;
            catrow1 = false;
            var resultsarr = Array.apply(null, Array(qtindex)).map(function () {});
            newrow["resultsarr"] = resultsarr;
            rows[sct.id] = newrow;
          }
        }
        this.rowsobj = rows;
          this.subscription2 = this.results$
           .subscribe(
             data => {
               for(var i=0;i<data.length;i++){
                 var res = data[i];
                 var colidx = this.qtindexobj[res.question_type];
                 this.rowsobj[res.sub_category].resultsarr[colidx] = res;
               }
                //go through each row
               for(var ri in this.rowsobj){
                 var rowresults = this.rowsobj[ri].resultsarr;
                 var count_yes = 0,count_non_empty=0, count_3_5=0;
                 var curr_qcat_name = '';
                 //go through each result in the row
                 for(var rri = 0; rri < rowresults.length; rri++){
                   var resobj = rowresults[rri];
                   if(resobj)
                   curr_qcat_name = resobj.question_category_group;
                   if(curr_qcat_name != ''){
                    count_non_empty++;
                    if(resobj && resobj.value=='Yes'){//if qtype is none of these
                      count_yes++;
                    }
                    else if (resobj && (resobj.value=='Unknown' || resobj.value=='Not applicable') ){
                      count_3_5++;
                    }
                    else if (this.qtindexrevarr[rri] == 'Response'){
                      //var avg_weight = weight_sum/qcat_count;
                      var avg_value;
                      if (count_non_empty-1==count_3_5){
                        avg_value=0;
                      }
                      else {
                      avg_value = count_yes/(count_non_empty-1);
                      avg_value*=100;
                      }
                      rowresults[rri] = {value:Math.round(avg_value) + "%"};
                      count_yes=0;
                      count_3_5=0;
                      count_non_empty=0;
                    }
                  }
                }
                this.rows.push(this.rowsobj[ri]);
              }
              this.empty_objects([this.rowsobj,this.qtindexobj]);
              this.qtindexrevarr = null;
              data = null;
this.qctypes_new = [
{'display_text':'1. Does the lead agency for this indicator have organisational structures of accountability to clients and constituents?',
'rspan':1,'cspan':2,'min_col_width':10},
{'display_text':'2. Do all stakeholders have fair and equitable access to the development and implementation of public policies for this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'Proportion of positive responses for Formulation of Policies',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'3. Regulatory Policy: If this indicator incorporates a regulatory component, please answer these questions. If it does not, please select \'not applicable\'.',
'rspan':1,'cspan':4,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'Regulatory Policy\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'4. Development Cooperation: If policy, planning or implementation of this indicator is fully or partly funded by an international donor, please answer these questions. If it does not, please select \'not applicable\'.',
'rspan':1,'cspan':5,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'Development Cooperation\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'5. Public Sector Integrity',
'rspan':1,'cspan':8,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'Public sector integrity\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'6. Whistle-blower Protection',
'rspan':1,'cspan':5,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'Regulatory Policy\'',
'rspan':2,'cspan':1,'min_col_width':10},];

this.qtypes_new = [
{
'display_text':'',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'f',
'min_col_width':10
},{
'display_text':'g',
'min_col_width':10
},{
'display_text':'h',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
}];

for(var i=0;i<this.qctypes_new.length;i++)
this.qctypes_new[i].min_col_width = parseInt((this.qctypes_new[i].display_text.length*1.5).toFixed(0));

for(var i=0;i<this.qtypes_new.length;i++)
this.qtypes_new[i].min_col_width = parseInt((this.qtypes_new[i].display_text.length*1.5).toFixed(0));

             },
             error => {
               this.alertService.error(error);
             });
             data = null;
       },
       error => {
           this.alertService.error(error);
       });
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

ngOnDestroy() {
  //  used in template
  this.qcgroups = null;
  this.qctypes = null;
  this.qtypes = null;
  this.rows = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

  resourcesBtnClick(){
      this.router.navigateByUrl('/sdg/transparency')
  }
  quesBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-quest')
  }
  dataBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-data')
  }
  reportBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-report')
  }

}



// WEBPACK FOOTER //
// ./src/app/sdg/transparency-data/transparency-data.component.ts